import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  MenuItem,
  InputAdornment,
  Typography,
} from "@mui/material";
import {
  AccountCircle,
  Email,
  Phone,
  Lock,
  Close,
  PersonAdd,
} from "@mui/icons-material";
import axios from "axios";

const AddCMTDialog = ({ open, onClose, compounds, onSuccess }) => {
  const [form, setForm] = useState({
    username: "",
    email: "",
    phone: "",
    password: "",
    confirm: "",
    compoundId: "",
    communication_method: "whatsapp",
  });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    setError("");
    if (!form.username || !form.email || !form.phone || !form.password) {
      setError("All fields except Compound are required.");
      return;
    }
    if (form.password !== form.confirm) {
      setError("Passwords do not match.");
      return;
    }
    setSaving(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/createCMT`,
        {
          username: form.username,
          email: form.email,
          phone: form.phone,
          password: form.password,
          compoundId: form.compoundId || null,
          communication_method: form.communication_method,
        },
        { withCredentials: true }
      );
      setForm({ username: "", email: "", phone: "", password: "", confirm: "", compoundId: "", communication_method: "whatsapp" });
      onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || "Failed to create CMT.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: "bold" }}>Add New CMT</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          {error && <Typography color="error" variant="body2">{error}</Typography>}
          <TextField label="Username" name="username" value={form.username} onChange={handleChange} fullWidth
            InputProps={{ startAdornment: <InputAdornment position="start"><AccountCircle /></InputAdornment> }} />
          <TextField label="Email" name="email" value={form.email} onChange={handleChange} fullWidth
            InputProps={{ startAdornment: <InputAdornment position="start"><Email /></InputAdornment> }} />
          <TextField label="Phone" name="phone" value={form.phone} onChange={handleChange} fullWidth
            InputProps={{ startAdornment: <InputAdornment position="start"><Phone /></InputAdornment> }} />
          <TextField label="Password" name="password" type="password" value={form.password} onChange={handleChange} fullWidth
            InputProps={{ startAdornment: <InputAdornment position="start"><Lock /></InputAdornment> }} />
          <TextField label="Confirm Password" name="confirm" type="password" value={form.confirm} onChange={handleChange} fullWidth
            InputProps={{ startAdornment: <InputAdornment position="start"><Lock /></InputAdornment> }} />
          <TextField label="Communication Method" name="communication_method" select value={form.communication_method} onChange={handleChange} fullWidth>
            <MenuItem value="whatsapp">WhatsApp</MenuItem>
            <MenuItem value="email">Email</MenuItem>
            <MenuItem value="both">Both</MenuItem>
          </TextField>
          <TextField label="Assign to Compound (optional)" name="compoundId" select value={form.compoundId} onChange={handleChange} fullWidth>
            <MenuItem value="">— None —</MenuItem>
            {(compounds || []).map((c) => (
              <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" color="primary" startIcon={<PersonAdd />} onClick={handleSubmit} disabled={saving}>
          {saving ? "Creating..." : "Create CMT"}
        </Button>
        <Button variant="outlined" startIcon={<Close />} onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddCMTDialog;
